module.exports = __webpack_public_path__ + "static/media/natours.30b4b649.png";